module.exports = __webpack_public_path__ + "img/2.e36008f2.jpg";